import { render, staticRenderFns } from "./PictureBookModal.vue?vue&type=template&id=2ff307ab&"
import script from "./PictureBookModal.vue?vue&type=script&lang=js&"
export * from "./PictureBookModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports